import { Route } from '@/app/router'

const Department = () => import('./index.vue')

export default new Route('/departments/:id', Department).as('Dashboard:Department').permissions(['VIEW_DEPARTMENTS'])
